"use strict";
'use es6'; // These should be removed once we have 100% adoption of UIApplication

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

require("../../listeners/focusStylesListener");

var _setupStyledComponents = require("../../listeners/setupStyledComponents");

var _jquery = _interopRequireDefault(require("jquery"));

var _I18n = _interopRequireDefault(require("I18n"));

var _SimpleDate = require("../../core/SimpleDate");

var _SimpleDateTypes = require("../../types/SimpleDateTypes");

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireWildcard(require("react-dom"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _UIControlledPopover = _interopRequireDefault(require("../../tooltip/UIControlledPopover"));

var _SyntheticEvent = _interopRequireDefault(require("../../core/SyntheticEvent"));

var _Functions = require("../../core/Functions");

var _createLazyPropType = _interopRequireDefault(require("../../utils/propTypes/createLazyPropType"));

var _domElement = _interopRequireDefault(require("../../utils/propTypes/domElement"));

var _RootNode = require("../../utils/RootNode");

var _lazyEval = _interopRequireDefault(require("../../utils/lazyEval"));

var _Dom = require("../../utils/Dom");

(0, _setupStyledComponents.setupStyledComponents)();
var EMPTY_REGEX = /^\s*$/; // We're constrained to formats that Pickadate can parse. Any format with spelled-out month
// names is liable to break (CRM-11620).

var supportedFormats = ['L', 'YYYY-MM-DD'];

var getSupportedFormat = function getSupportedFormat(format) {
  return supportedFormats.includes(format) ? format : 'L';
};

var expandDateFormat = function expandDateFormat(format) {
  // Expand the shorthand format, e.g. "L" become "MM/DD/YYYY" or "DD/MM/YYYY" based on the locale
  var i18nData = (_I18n.default.moment.localeData || _I18n.default.moment.langData)();

  return i18nData.longDateFormat(format) || format;
};

var getValueIsValid = function getValueIsValid(value) {
  return !value || (0, _SimpleDate.isValid)(value);
};

var getBoundedValue = function getBoundedValue(value, minValue, maxValue) {
  if (minValue != null && value != null && (0, _SimpleDate.compare)(value, minValue) === -1) {
    return minValue;
  } else if (maxValue != null && value != null && (0, _SimpleDate.compare)(value, maxValue) === 1) {
    return maxValue;
  }

  return value;
};

var getValueIsInBounds = function getValueIsInBounds(value, minValue, maxValue) {
  return getBoundedValue(value, minValue, maxValue) === value;
};

var getReadableDate = function getReadableDate(format, value) {
  if (!getValueIsValid(value)) {
    return _I18n.default.text('ui.datePicker.invalidDate');
  }

  if (!value) {
    return '';
  }

  return (0, _SimpleDate.toMoment)(value).format(getSupportedFormat(format));
};

var _default = _react.default.createClass({
  displayName: "UIAbstractDateInput",
  propTypes: {
    children: _react.PropTypes.func.isRequired,
    clearable: _react.PropTypes.bool,
    clearLabel: _react.PropTypes.string,
    datepickerClassName: _react.PropTypes.string,
    disabledValues: _react.PropTypes.arrayOf(_SimpleDateTypes.SimpleDateType),
    error: _react.PropTypes.bool,
    format: _react.PropTypes.oneOf(supportedFormats).isRequired,
    maxValue: _SimpleDateTypes.SimpleDateType,
    maxValueValidationMessage: (0, _createLazyPropType.default)(_react.PropTypes.string),
    minValue: _SimpleDateTypes.SimpleDateType,
    minValueValidationMessage: (0, _createLazyPropType.default)(_react.PropTypes.string),
    onChange: _react.PropTypes.func.isRequired,
    placeholder: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.string]),
    readOnly: _react.PropTypes.bool,
    todayLabel: _react.PropTypes.string,
    value: _SimpleDateTypes.SimpleDateType,
    _bodyElement: _domElement.default
  },
  getDefaultProps: function getDefaultProps() {
    return {
      clearable: true,
      format: 'L',
      maxValueValidationMessage: function maxValueValidationMessage() {
        return _I18n.default.text('ui.datePicker.dateAboveMax');
      },
      minValueValidationMessage: function minValueValidationMessage() {
        return _I18n.default.text('ui.datePicker.dateBelowMin');
      },
      placeholder: expandDateFormat
    };
  },
  getInitialState: function getInitialState() {
    return {
      hasFocus: false,
      isPickerOpen: false,
      userTextInput: ''
    };
  },
  componentWillMount: function componentWillMount() {
    if (!_jquery.default.fn.pickadate) {
      _devLogger.default.warn({
        message: 'UIAbstractDateInput: Pickadate not loaded. See https://git.hubteam.com/HubSpot/UIComponents/issues/2160',
        key: 'UIAbstractDateInput:PickadateNotLoaded'
      });
    }

    if (!window.hubspot.baldric) {
      _devLogger.default.warn({
        message: 'UIAbstractDateInput: Baldric not loaded. See https://git.hubteam.com/HubSpot/UIComponents/issues/2160',
        key: 'UIAbstractDateInput:BaldricNotLoaded'
      });
    }
  },
  componentDidMount: function componentDidMount() {
    if (!this._el) return; // Check if we've been autoFocused and, if so, update state to reflect that.

    var hasFocus = this._el.contains(document.activeElement);

    if (hasFocus && !this.state.hasFocus) {
      this.setState((0, _extends2.default)({
        hasFocus: true
      }, this.getOpenState()));
    }
  },
  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
    if (!prevState.isPickerOpen && this.state.isPickerOpen) {
      this.initPickadate();
    } else if (prevState.isPickerOpen && !this.state.isPickerOpen) {
      this.destroyPickadate();
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    var _bodyElement = this.props._bodyElement;
    this.destroyPickadate();

    if (this._tooltipRootEl) {
      (_bodyElement || (0, _RootNode.getDefaultNode)()).removeChild(this._tooltipRootEl);
    }
  },
  focus: function focus() {
    if (this._input != null) {
      this._input.focus();
    }
  },
  select: function select() {
    if (this._input != null) {
      this._input.select();
    }
  },
  initPickadate: function initPickadate() {
    var _this$props = this.props,
        clearLabel = _this$props.clearLabel,
        format = _this$props.format,
        minValue = _this$props.minValue,
        maxValue = _this$props.maxValue,
        disabledValues = _this$props.disabledValues,
        readOnly = _this$props.readOnly,
        todayLabel = _this$props.todayLabel,
        value = _this$props.value;

    if (readOnly) {
      return;
    }

    if (this.getPicker()) {
      return;
    }

    var containerEl = (0, _reactDom.findDOMNode)(this._container);

    if (!containerEl) {
      return;
    }

    var disabledArr;

    if (disabledValues) {
      disabledArr = disabledValues.map(_SimpleDate.toArray);
    }

    this.$getPickerNode().pickadate({
      container: containerEl,
      onSet: this.handlePickadateChange,
      onClose: this.handlePickadateClose,
      editable: false,
      format: expandDateFormat(getSupportedFormat(format)).toLowerCase(),
      min: (0, _SimpleDate.toArray)(minValue) || undefined,
      max: (0, _SimpleDate.toArray)(maxValue) || undefined,
      disable: disabledArr,
      today: todayLabel,
      clear: clearLabel,
      select: (0, _SimpleDate.toArray)(value)
    });
  },
  destroyPickadate: function destroyPickadate() {
    var picker = this.getPicker();

    if (picker) {
      picker.stop();
    }
  },
  getPicker: function getPicker() {
    return this.$getPickerNode().pickadate('picker');
  },
  $getPickerNode: function $getPickerNode() {
    var $node = (0, _jquery.default)((0, _reactDom.findDOMNode)(this._input));

    if ($node.is('input')) {
      return $node;
    }

    return $node.find('input');
  },
  getOpenState: function getOpenState() {
    return {
      isPickerOpen: true
    };
  },
  getClosedState: function getClosedState() {
    var _this$props2 = this.props,
        format = _this$props2.format,
        value = _this$props2.value;
    return {
      isPickerOpen: false,
      userTextInput: getReadableDate(format, value)
    };
  },
  triggerChange: function triggerChange(newValue) {
    var _this$props3 = this.props,
        maxValue = _this$props3.maxValue,
        minValue = _this$props3.minValue,
        onChange = _this$props3.onChange,
        value = _this$props3.value;

    if (newValue === null && value !== newValue) {
      onChange((0, _SyntheticEvent.default)(null));
      return;
    }

    var boundedNewValue = getBoundedValue(newValue, minValue, maxValue);
    if ((0, _SimpleDate.equals)(boundedNewValue, value)) return;
    onChange((0, _SyntheticEvent.default)(boundedNewValue));
  },
  handleKeyDown: function handleKeyDown(evt) {
    if (evt.key === 'Enter') {
      this.setState((0, _extends2.default)({}, this.getOpenState()));
    }
  },
  handleKeyUp: function handleKeyUp(evt) {
    if (evt.key === 'Enter') {
      evt.preventDefault();
      evt.stopPropagation();
    }
  },
  handlePickadateChange: function handlePickadateChange() {
    var pickadateVal = this.getPicker().get('select');
    var newValue = pickadateVal && (0, _SimpleDate.fromPickadate)(pickadateVal);
    this.triggerChange(newValue);
  },
  handlePickadateClose: function handlePickadateClose() {
    var _this$props4 = this.props,
        format = _this$props4.format,
        value = _this$props4.value;
    var input = this.$getPickerNode()[0];

    if (input) {
      input.value = getReadableDate(format, value); // replace Pickadate-set value
    }

    this.setState((0, _extends2.default)({}, this.getClosedState()));
  },
  handleChange: function handleChange(evt) {
    if (this.props.readOnly) {
      return;
    }

    var userTextInput = evt.target.value;
    this.handleUserTextInput(userTextInput);
  },
  handlePaste: function handlePaste(evt) {
    try {
      var userTextInput = evt.nativeEvent.clipboardData.getData('text/plain');
      this.handleUserTextInput(userTextInput);
    } catch (error) {
      /* Browser is being weird, just ignore it */
    }
  },
  handleUserTextInput: function handleUserTextInput(userTextInput) {
    var rawMoment = _I18n.default.moment(userTextInput, getSupportedFormat(this.props.format));

    var newValue = EMPTY_REGEX.test(userTextInput) ? null : (0, _SimpleDate.fromMoment)(rawMoment);

    if (getValueIsValid(newValue)) {
      this.triggerChange(newValue);
    }

    this.setState({
      userTextInput: userTextInput
    });
  },
  handleBlur: function handleBlur(evt) {
    var onBlur = this.props.onBlur;
    this.setState({
      hasFocus: false
    });
    (0, _Functions.callIfPossible)(onBlur, evt);
  },
  handleFocus: function handleFocus(evt) {
    var onFocus = this.props.onFocus;
    this.setState((0, _extends2.default)({
      hasFocus: true
    }, this.getOpenState()));
    (0, _Functions.callIfPossible)(onFocus, evt);
  },
  handleMouseDown: function handleMouseDown(evt) {
    // While the input has focus, mousedown should toggle the picker
    var onMouseDown = this.props.onMouseDown;

    if (this.state.hasFocus) {
      if (this.state.isPickerOpen) {
        this.setState((0, _extends2.default)({}, this.getClosedState()));
      } else {
        this.setState((0, _extends2.default)({}, this.getOpenState()));
      }
    }

    (0, _Functions.callIfPossible)(onMouseDown, evt);
  },
  handleContainerMouseenter: function handleContainerMouseenter(evt) {
    // If the mouse is within a disabled day, we want to show a tooltip to explain why it's disabled.
    var _this$props5 = this.props,
        minValue = _this$props5.minValue,
        minValueValidationMessage = _this$props5.minValueValidationMessage,
        maxValue = _this$props5.maxValue,
        maxValueValidationMessage = _this$props5.maxValueValidationMessage;
    var disabledDateEl = (0, _Dom.closest)(evt.target, '.picker__day--disabled');

    if (disabledDateEl) {
      var dateTimestamp = +disabledDateEl.getAttribute('data-pick');

      if (minValue != null && dateTimestamp < (0, _SimpleDate.toMoment)(minValue).valueOf()) {
        this.attachTooltip(disabledDateEl, (0, _lazyEval.default)(minValueValidationMessage));
      } else if (maxValue != null && dateTimestamp > (0, _SimpleDate.toMoment)(maxValue).valueOf()) {
        this.attachTooltip(disabledDateEl, (0, _lazyEval.default)(maxValueValidationMessage));
      }
    }
  },
  attachTooltip: function attachTooltip(target, message) {
    var _this = this;

    // We have to mount a new React tree to hold our UIPopover, though it won't actually have any content.
    var _bodyElement = this.props._bodyElement;

    if (!this._tooltipRootEl) {
      this._tooltipRootEl = document.createElement('div');

      (_bodyElement || (0, _RootNode.getDefaultNode)()).appendChild(this._tooltipRootEl);
    } // We can't use UITooltip here because that component's target must be its child.


    var popover = _react.default.createElement(_UIControlledPopover.default, {
      open: true,
      use: "tooltip",
      target: target,
      content: _react.default.createElement("div", {
        className: "private-tooltip__inner"
      }, message)
    });

    _reactDom.default.render(popover, this._tooltipRootEl);

    target.addEventListener('mouseleave', function () {
      _reactDom.default.unmountComponentAtNode(_this._tooltipRootEl);
    });
  },
  refCallback: function refCallback(ref) {
    this._el = ref;
  },
  containerRefCallback: function containerRefCallback(ref) {
    this._container = ref;

    if (ref) {
      ref.addEventListener('mouseenter', this.handleContainerMouseenter, true);

      if (this.state.isPickerOpen) {
        this.initPickadate();
      }
    }
  },
  inputRefCallback: function inputRefCallback(ref) {
    this._input = ref;
  },
  renderChild: function renderChild(_ref) {
    var children = _ref.children,
        error = _ref.error,
        format = _ref.format,
        maxValue = _ref.maxValue,
        minValue = _ref.minValue,
        placeholder = _ref.placeholder,
        readOnly = _ref.readOnly,
        rest = _ref.rest,
        value = _ref.value;
    (0, _invariant.default)(typeof children === 'function', 'UIAbstractDateInput: this.props.children must be a function but got %s', children);
    var _this$state = this.state,
        hasFocus = _this$state.hasFocus,
        isPickerOpen = _this$state.isPickerOpen,
        userTextInput = _this$state.userTextInput;
    var userIsTyping = hasFocus && !isPickerOpen;
    var supportedFormat = getSupportedFormat(format);
    return children((0, _extends2.default)({}, rest, {
      'aria-invalid': error === true || !getValueIsValid(value) || !getValueIsInBounds(value, minValue, maxValue),
      'data-format': expandDateFormat(supportedFormat),
      isPickerOpen: isPickerOpen,
      onBlur: this.handleBlur,
      onFocus: this.handleFocus,
      onChange: this.handleChange,
      onMouseDown: this.handleMouseDown,
      onPaste: this.handlePaste,
      placeholder: typeof placeholder === 'function' ? placeholder(supportedFormat) : placeholder,
      readOnly: readOnly,
      ref: this.inputRefCallback,
      value: userIsTyping ? userTextInput : getReadableDate(supportedFormat, value)
    }));
  },
  render: function render() {
    var _this$props6 = this.props,
        _bodyElement = _this$props6._bodyElement,
        children = _this$props6.children,
        className = _this$props6.className,
        clearable = _this$props6.clearable,
        datepickerClassName = _this$props6.datepickerClassName,
        __disabledValues = _this$props6.disabledValues,
        error = _this$props6.error,
        format = _this$props6.format,
        minValue = _this$props6.minValue,
        __minValueValidationMessage = _this$props6.minValueValidationMessage,
        maxValue = _this$props6.maxValue,
        __maxValueValidationMessage = _this$props6.maxValueValidationMessage,
        __onBlur = _this$props6.onBlur,
        __onChange = _this$props6.onChange,
        __onFocus = _this$props6.onFocus,
        placeholder = _this$props6.placeholder,
        readOnly = _this$props6.readOnly,
        value = _this$props6.value,
        rest = (0, _objectWithoutProperties2.default)(_this$props6, ["_bodyElement", "children", "className", "clearable", "datepickerClassName", "disabledValues", "error", "format", "minValue", "minValueValidationMessage", "maxValue", "maxValueValidationMessage", "onBlur", "onChange", "onFocus", "placeholder", "readOnly", "value"]);
    return (
      /* eslint-disable jsx-a11y/no-static-element-interactions */
      _react.default.createElement("div", {
        className: (0, _classNames.default)('hs-pickadate', className),
        onKeyDown: this.handleKeyDown,
        onKeyUp: this.handleKeyUp,
        ref: this.refCallback
      }, _react.default.createElement(_UIControlledPopover.default, {
        arrowSize: "none",
        autoPlacement: "vert",
        content: _react.default.createElement("div", {
          className: (0, _classNames.default)('private-datepicker', datepickerClassName, {
            'private-datepicker--unclearable': !clearable,
            'private-datepicker--disable-today': !getValueIsInBounds((0, _SimpleDate.now)(), minValue, maxValue)
          }),
          ref: this.containerRefCallback
        }),
        open: this.state.isPickerOpen,
        pinToConstraint: ['left', 'right'],
        placement: "bottom right",
        use: "unstyled",
        _bodyElement: _bodyElement
      }, this.renderChild({
        children: children,
        error: error,
        format: format,
        maxValue: maxValue,
        minValue: minValue,
        placeholder: placeholder,
        readOnly: readOnly,
        rest: rest,
        value: value
      })))
      /* eslint-enable jsx-a11y/no-static-element-interactions */

    );
  }
});

exports.default = _default;
module.exports = exports.default;